<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-truck"></span>{{ 'bikeshop.menu.special_orders' | translate }}</div>
    </div>
    <div class="content">
        <div class="row">
            <div class="col-md-12">
                <div
                        tooltipPosition="left"
                        class="fa hubtiger-sync font-button pull-right"
                        [ngClass]="{ 'fa-spin': loading }"
                        style="margin-left: auto!important;margin-right: 16px!important;text-align: center;line-height: 33px;"
                        (click)="refreshOrders()"></div>
            </div>
        </div>
        <div>
            <p-table #ordersTable [columns]="columns" [value]="orders">
                <ng-template pTemplate="caption">
                    <!--                    <div style="display: flex">-->
                    <!--                        <div class="p-inputgroup" style="margin-left: auto;">-->
                    <!--                            &lt;!&ndash;              todo (dcorbett ) target doesnt work&ndash;&gt;-->
                    <!--                            <input type="text" pInputText size="50" placeholder="{{ 'general.search' | translate }}"-->
                    <!--                                   (input)="ordersTable.filterGlobal($event.target['value'] , 'contains')"-->
                    <!--                                   style="width:auto">-->
                    <!--                            <span class="p-inputgroup-addon"-->
                    <!--                            ><i class="fa hubtiger-search"></i-->
                    <!--                            ></span>-->
                    <!--                            &lt;!&ndash; todo (dcorbett)  removed (click)="searchCyclist()"&ndash;&gt;-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <div class="row  justify-content-end mb-2">
                        <div class="col-3 d-flex">
                            <input type="text" pInputText placeholder="Search"
                                   (input)="ordersTable.filterGlobal($event.target['value'] , 'contains')"
                                   style="width:100%">
                            <i class="fa fa-search" style="margin-left: -30px; margin-top: 15px"></i>
                        </div>
                    </div>


                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                            [ngStyle]="{ 'width' : col.width ? col.width : 'auto'}">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-jobcard let-columns="columns">
                    <tr [pSelectableRow]="jobcard">
                        <td *ngFor="let col of columns">
                            <div *ngIf="col.type=='jobcardno'">
                                <div (click)="openJobCard(jobcard.serviceID)" style="cursor: pointer">
                                    <u>{{jobcard[col.field]}}</u>
                                </div>
                            </div>
                            <div *ngIf="col.type!=='action' && col.type!=='jobcardno'"
                                 [ngClass]="{ 'status' : col.type === 'status', 'ready': col.type === 'status' && isReady(jobcard['status']), 'not-ordered': col.type === 'status' && isNotOrdered(jobcard['status']), 'ordered' : col.type === 'status' && isOrdered(jobcard['status']) }">
                                {{
                                col.type === 'date' ?
                                    (jobcard[col.field] | date : countryData.AngularDateFormat)
                                    : jobcard[col.field]
                                }}
                            </div>
                            <!--todo(dcorbett) removed && activeItem.action , (click)="processAction(jobcard)" -->
                            <div *ngIf="col.type==='action'" style="display: grid;">
                                <button pButton type="button" class="p-button-raised icon"
                                        icon="pi pi-spin pi-spinner" iconPos="right"
                                        [disabled]="jobcard.busy"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!--<div>
        <small>
          {{ 'bikeshop.cyclist.note' | translate }}
        </small>
      </div>-->
    </div>
</div>


<div class="container-fluid" style="margin-top: 32px;" *ngIf="outOfStockItems && outOfStockItems.length > 0">
    <div class="content">
        <div>
            <p-table #ordersTable [columns]="columns" [value]="outOfStockItems">
                <ng-template pTemplate="caption">
                    <div style="display: flex; align-items: center;">
                        <div>
                            <div>
                                <div class="out-of-stock-header">{{ 'bikeshop.menu.items_out_of_stock' | translate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="out-of-stock-info">{{'bikeshop.out_of_stock_info' | translate }}</div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of outOfStockColumns"
                            [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                            [ngStyle]="{ 'width' : col.width ? col.width : 'auto'}">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-jobcard let-columns="columns">
                    <tr [pSelectableRow]="jobcard">
                        <td *ngFor="let col of outOfStockColumns">
                            <div *ngIf="col.type=='jobcardno'">
                                <div (click)="openJobCard(jobcard.serviceID)" style="cursor: pointer">
                                    <u>{{jobcard[col.field]}}</u>
                                </div>
                            </div>
                            <div *ngIf="col.type!=='action' && col.type!=='jobcardno'">
                                {{
                                col.type === 'date' ?
                                    (jobcard[col.field] | date : countryData.AngularDateFormat)
                                    : jobcard[col.field]
                                }}
                            </div>

                            <!--todo(dcorbett) removed && activeItem.action , (click)="processAction(jobcard)" -->
                            <div *ngIf="col.type==='action'" style="display: grid;">
                                <button pButton type="button" class="p-button-raised icon" icon="pi pi-spin pi-spinner"
                                        iconPos="right"
                                        [disabled]="jobcard.busy"></button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!--<div>
        <small>
          {{ 'bikeshop.cyclist.note' | translate }}
        </small>
      </div>-->
    </div>
</div>
